import { render, staticRenderFns } from "./RoomAssignmentPanel.vue?vue&type=template&id=0476a3a5&scoped=true"
import script from "./RoomAssignmentPanel.vue?vue&type=script&lang=js"
export * from "./RoomAssignmentPanel.vue?vue&type=script&lang=js"
import style0 from "./RoomAssignmentPanel.vue?vue&type=style&index=0&id=0476a3a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476a3a5",
  null
  
)

export default component.exports